<template>
  <div class="w1200 footer" :style="{ background: src }">
    <!-- <div class="contactus">
      <span>联系我们</span>
      <span class="phone">{{ phone }}</span>
    </div> -->
    <div class="copyright">
      <span>{{ copyright }}</span>
      <span>{{ address }}</span>
    </div>
    <div class="copyrighttext" @click="showCopyright">
        Copyright © 2020 Mools.net All Rights Reserved | 辽ICP备17015248号-1
    </div>
  </div>
</template>

<script>
import { getFooter } from "@/api/components/footer";

export default {
  name: "Footer",
  data() {
    return {
      src: "url(" + require("@/assets/image/footer.png") + ")",
      phone: null,
      copyright: null,
      address: null
    };
  },
  watch: {
    "$route.query.School_id": function(School_id) {
      this.handleGetFooter(School_id);
    }
  },
  created() {
    this.handleGetFooter(this.$route.query.School_id);
  },
  methods: {
    showCopyright(){
      window.open('https://beian.miit.gov.cn/');
    },
    handleGetFooter(School_id) {
      if (School_id) {
        console.log(School_id);
        getFooter(School_id).then(res => {
          res.data = res.data || {};
          this.phone = res.data.phone || "0411-83010751";
          // ADD BY LANXINYU ==================================================================
          if(School_id == 'MTA0')
          {
            this.copyright = "版权所有©西安电子科技大学";
            this.address = "技术支持 : 慕乐网络科技（大连）有限公司";
          }
          else
          {
            this.copyright =
              res.data.copyright || "版权所有©慕乐网络科技（大连）有限公司";
            this.address =
            res.data.address ||
            "辽宁省大连市西岗区同庆街57号大连理工大学科创产业园606";
          }
          // =============================================================================================

        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.copyrighttext{
  padding-bottom: 1rem;
  cursor: pointer;
  color: #FFFFFF;
  font-size: .8rem;
}
.footer {
  padding-top: 20px;
  color: #fff;

  .contactus {
    border-bottom: 1px dotted #fff;
    padding-bottom: 30px;

    .phone {
      display: inline-block;
      width: 150px;
      padding: 10px;
      margin-left: 75px;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAOBJREFUKBWVkr0NwjAQhSOaVOnYIBVLAGEAqCgYh2zDDCBRQRs2IAtQpQXM94idHBEW4klP9/vks31JYuCcy+AWXmDjWflcZlp7l2IBaxiDaotegacEfMYUJq+eVoyj8exJR+IbjEG9mU7TnQKOGoVgGhIRW47oW6nZ4+HtOCQidilhbopzTpgQpyb3zc01lp7d4kSQwtImB34jof5siB0JiTdwDWfQPlgloX0cwg5nPI39Bv6hq6CRcPgdpu7uBHtoRVfidotwtDX/LYAZRdtTwxhUK0L/h6WgsXXnn0v+AgsFGzYHH77/AAAAAElFTkSuQmCC)
        0 no-repeat;
    }

    .email {
      display: inline-block;
      width: 180px;
      padding: 10px;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAALCAYAAACksgdhAAAAAXNSR0IArs4c6QAAAJxJREFUKBWVkE0KwjAUhN8TegE3iq4V9Ax6st5A9ALt1kW3HsudC0VohPQbaSGCi2TgI+9nhpBYjPEMAXIk32VmZi/oIUfyPY3kBlbQwgf+SXPt5dsq1EMDa9jBDVKp34P28gWFJr0pTjCHA1zhOPaaa/9VGppmD4oaluOp/keuLucHUo9+r1gKld4UFeoKr+pcAZ614KgywsHd7wPzAwJiN3UU8AAAAABJRU5ErkJggg==)
        0 no-repeat;
    }
  }

  .copyright {
    padding: 20px 0;

    span {
      display: inline-block;
      width: 40%;
    }
  }
}
</style>
